module.exports = __webpack_public_path__ + "static/media/user.5d2bc1c6.svg";